module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAThJREFUKBWdk7/qglAcxY+XSzSEQ1I4iVu2O4l79Aw+QD2Ju4/QCzQ7OIYgOgY2SeRiQ1uBQ39+v6/glwRdOqB+zz2fA3K9Kp9/4QeJHzpNRbZF27ZhWVZrEccxHMdhfzqdkGUZe5nnOW63GxaLBVzX5UAI0Sm+328cDgdomoblcgmx2WxwPB7xer241DdQkTjiScI0TWy3W4xGoz6e1ygnjnjS4Ob4vt8AQzfeHAIejweqqmrYIAi4o+s6z+3AxbqusVqt8Hw+24yfUkokScKeBi4WRYHdbtcJvw3l3+Lifr+HYRjfWWe+XC4dL8/nMzzPg6IonaDP0Oksy7KJJH306/WKyWTSx3bW7vc7H5LmVVVVxXq9Bh27IaVpijAMORbj8RhRFGE2m2E6nQ5e8/m84YgnKb/+Vn+HxGqKwQWtDQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/sofa.png
// module id = 517
// module chunks = 0